import React, { useState, useEffect } from "react";
import "./Hero.css";
import { Link } from "react-router-dom";
import { images } from "../../../assets";

function Hero({ totalStats }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  const formatTotalRaised = (totalRaised) => {
    if (totalRaised >= 1000000000000) {
      return `${(totalRaised / 1000000000000).toFixed(1)} T`;
    } else if (totalRaised >= 1000000000) {
      return `${(totalRaised / 1000000000).toFixed(1)} B`;
    } else if (totalRaised >= 1000000) {
      return `${(totalRaised / 1000000).toFixed(1)} M`;
    } else {
      return totalRaised;
    }
  };

  const data = [
    {
      id: 1,
      userSpeaking: "I raised ",
      highlight: "₹20",
      userSpeaking2: " today just by walking on Impact app",
      userImg: images.girlPh,
      userDp: images.userIdentityPhoto,
      userName: "Priyanka Chopra",
      userInfo: "₹12,000",
    },
    {
      id: 2,
      userSpeaking: "Thank you for giving me quality ",
      highlight: "education",
      userSpeaking2: ".",
      userImg: images.boyPh,
      userDp: images.boyIdentityphoto,
      userName: "Omkar Patil",
      userInfo: "5th standard",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % data.length);
    }, 5000); // Change data every 5 seconds (5000 milliseconds)

    return () => clearInterval(interval);
  }, [data.length]);

  return (
    <div className="hero">
      <div className="hero-container gridtable">
        <div className="leftblock">
          <div className="hero-content">
            <div className="hero-content-top">
              <div className="heading">
                <div className="line1">Make a</div>
                <div className="difference">difference </div>
                <div className="line3">
                  <div className="withyour">with your</div>
                  <div className="steps">steps</div>
                </div>
              </div>
              <div>
                <div className="herodescription">
                  Making fitness meaningful and rewarding
                </div>
              </div>
            </div>
            <div className="hero-content-bottom">
              <div className="reviewrow">
                <div className="review">
                  <div className="rating">
                    4.6 <img src={images.star} alt="star" />
                  </div>
                  <div className="reviewtext">100K reviews</div>
                </div>
                <div className="downloadnum">
                  <div className="million">5 M</div>
                  <div className="downloadtext">Downloads</div>
                </div>
                <div className="charityraised">
                  <div className="billion">
                  ₹{totalStats && formatTotalRaised(totalStats.total_raised)}
                  </div>
                  <div className="charitytext">Charity raised</div>
                </div>
              </div>

              <div className="button">
                <Link to="https://play.google.com/store/apps/details?id=com.sharesmile.share&hl=en">
                  {" "}
                  <img
                    src={images.playStore}
                    alt="google-play"
                  />{" "}
                </Link>
                <Link to="https://apps.apple.com/in/app/impact-fitness-charity/id1143265464">
                  {" "}
                  <img src={images.appleStore} alt="apple-app" />{" "}
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="rightblock">
          <img className="rightimage" src={images.rightBlock} alt="right-block" />
          <img
            className={currentIndex === 1 ? "boyph" : "girlph"}
            src={data[currentIndex].userImg} alt="user"
          />
          <div className="userspeaking">
            {data[currentIndex].userSpeaking}
            <span className="highlight">{data[currentIndex].highlight}</span>
            {data[currentIndex].userSpeaking2}
          </div>
          <div className="userIdentity">
            <div className="userIdentityphoto">
              <img src={data[currentIndex].userDp} alt="user dp" />
            </div>
            <div className="userIdentityContent">
              <div className="userIdentityName">
                {data[currentIndex].userName}
              </div>
              <div className="userIdentityDonation">
                <span className="donationAmount">
                  {data[currentIndex].userInfo}
                </span>
                {data[currentIndex].id === 1 ? (
                  <span className="donationWord">donated</span>
                ) : null}
              </div>
            </div>
          </div>
        </div> 
      </div>

      <div className="leftBlockMobile">
            <div className="hero-content-top">
              <div className="heading">
                <div className="headingText">Make a
                <span className="difference"> difference </span>
                with your
                <span className="steps"> steps</span></div>
                
              </div>
              <div>
                <div className="herodescription">
                  Making fitness meaningful and rewarding
                </div>
              </div>
            </div>
            <div className="rightblockMobile">
          <img className="rightimage" src={images.rightBlock} alt="right-block" />
          <img
            className={currentIndex === 1 ? "boyph" : "girlph"}
            src={data[currentIndex].userImg} alt="user"
          />
          <div className="userspeaking">
            {data[currentIndex].userSpeaking}
            <span className="highlight">{data[currentIndex].highlight}</span>
            {data[currentIndex].userSpeaking2}
          </div>
          <div className="userIdentity">
            <div className="userIdentityphoto">
              <img src={data[currentIndex].userDp} alt="user dp" />
            </div>
            <div className="userIdentityContent">
              <div className="userIdentityName">
                {data[currentIndex].userName}
              </div>
              <div className="userIdentityDonation">
                <span className="donationAmount">
                  {data[currentIndex].userInfo}
                </span>
                {data[currentIndex].id === 1 ? (
                  <span className="donationWord">donated</span>
                ) : null}
              </div>
            </div>
          </div>
            </div>
            <div className="hero-content-bottom">
              <div className="reviewrow">
                <div className="review">
                  <div className="rating">
                    4.6 <img src={images.star} alt="star" />
                  </div>
                  <div className="reviewtext">100K reviews</div>
                </div>
                <div className="downloadnum">
                  <div className="million">5 M</div>
                  <div className="downloadtext">Downloads</div>
                </div>
                <div className="charityraised">
                  <div className="billion">
                  ₹{totalStats && formatTotalRaised(totalStats.total_raised)}
                  </div>
                  <div className="charitytext">Charity raised</div>
                </div>
              </div>

              <div className="button">
                <Link to="https://play.google.com/store/apps/details?id=com.sharesmile.share&hl=en">
                  {" "}
                  <img
                    src={images.playStore}
                    alt="google-play"
                  />{" "}
                </Link>
                <Link to="https://apps.apple.com/in/app/impact-fitness-charity/id1143265464">
                  {" "}
                  <img src={images.appleStore} alt="apple-app" />{" "}
                </Link>
              </div>
            </div>
      </div>
    </div>
  );
}

export default Hero;
